export interface FlocktoryUserOrdersDataLayerData {
  ordersCount: number;
  lastOrderDate: string | null;
  hasEmail: 0 | 1;
}

const FLOCKTORY_USER_ORDERS_EVENT = 'delikateska_user_orders';

export const pushFlocktoryUserOrdersToDataLayer = ({
  ordersCount,
  lastOrderDate,
  hasEmail
}: FlocktoryUserOrdersDataLayerData): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: FLOCKTORY_USER_ORDERS_EVENT,
    delikateska_orders_count: ordersCount,
    delikateska_has_orders: ordersCount > 0,
    delikateska_last_order_date: lastOrderDate,
    delikateska_has_email: hasEmail
  });
};

export const pushFlocktoryGuestOrdersToDataLayer = (): void => {
  pushFlocktoryUserOrdersToDataLayer({
    ordersCount: 0,
    lastOrderDate: null,
    hasEmail: 0
  });
};
